import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { t } from '../../services/i18nService';
import modalUtils from '../../qti/utils/ModalUtils';
import styles from './DrawingDeleteConfirmModal.scss';

const DrawingDeleteConfirmModal = ({
    isAuthorDrawingBgEdit,
    isOpen,
    onClose,
    onConfirm,
    onDismiss,
    isSaving,
}) => {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const handleClose = () => {
        onClose();
    };
    const handleDismiss = () => {
        onDismiss();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleClose}
            style={modalUtils.confirmationModalStyles}
            tabIndex="0"
            ariaHideApp={false}
        >
            <div className={styles.modalWrapper}>
                <div className={isAuthorDrawingBgEdit ? styles.headerContainerDiscard : styles.headerContainer}>
                    <div className={styles.header}>
                        <h2 className={isAuthorDrawingBgEdit ? styles.modalTitleForClose : styles.modalTitle}>
                            {isAuthorDrawingBgEdit ? t('interactions.drawing.discardChanges.title') :
                                t('interactions.drawing.deleteConfirmModal.title')}
                        </h2>
                    </div>
                    <div className={isAuthorDrawingBgEdit ? styles.toolbarForClose : styles.toolbar}>
                        <button
                            className={styles.closeButton}
                            onClick={handleDismiss}
                        >
                            <span className="sr-only">{t('general.close')}</span>
                            <i className="fa fa-times" aria-hidden="true" />
                        </button>
                    </div>
                </div>

                <div className={styles.modalContent}>
                    <p className={styles.modalDescription}>
                        { isAuthorDrawingBgEdit ? t('interactions.drawing.closeConfirm.description') :
                            t('interactions.drawing.deleteConfirmModal.description')
                        }
                    </p>
                </div>

                <div className={styles.modalFooter}>
                    <button
                        onClick={handleConfirm}
                        className={styles.deleteButton}
                        disabled={isSaving}
                    > { isAuthorDrawingBgEdit ? t('interactions.drawing.closeConfirm.close') :
                            t('interactions.drawing.deleteConfirmModal.delete')}
                    </button>
                    <button
                        onClick={handleClose}
                        className={styles.cancelButton}
                        disabled={isSaving}
                    >
                        { isAuthorDrawingBgEdit ?
                            t('interactions.drawing.closeConfirm.saveAndClose') :
                            t('interactions.drawing.deleteConfirmModal.cancel') }
                    </button>
                </div>
            </div>
        </Modal>
    );
};

DrawingDeleteConfirmModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
    isAuthorDrawingBgEdit: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
};

export default DrawingDeleteConfirmModal;
